import type { VolumeProfileAction } from './actions';
import type { VolumeProfileState } from './types';

export function reducer(state: VolumeProfileState, action: VolumeProfileAction): VolumeProfileState {
    switch (action.type) {
        case 'SET_TAB':
            if (state.tabId === action.tabId) return state;
            return { ...state, tabId: action.tabId };
        case 'SET_VIEW_MODE':
            if (state.viewMode === action.viewMode) return state;
            return { ...state, viewMode: action.viewMode };
        case 'SET_SESSION':
            if (state.session === action.session) return state;
            return { ...state, session: action.session };
        case 'SET_RANGE':
            if (state.range === action.range) return state;
            return { ...state, range: action.range };
        case 'TOGGLE_OVERLAY':
            return {
                ...state,
                overlays: {
                    ...state.overlays,
                    [action.overlay]: !state.overlays[action.overlay],
                },
            };
        default: {
            const _exhaustiveCheck: never = action;
            return state;
        }
    }
}
